import { initStore, USERS_SEARCH_TYPES } from '../../../common';
import { actions } from './actions';

export const usersStore = (): void => {
	const initialState = {
		slice: 'USERS',
		allUsers: [],
		users: [],
		usersLoading: false,
		savingData: false,
		reports: [],
		selectedReports: [],
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		perPage: '10',
		bulkRows: [],
		columns: [],
		partners: [],
		permissions: [],
		roles: [],
		activePartners: [],
		activePermissions: [],
		mailReportModal: null,
		activeRoles: [],
		filtering: false,
		filters: [{ name: 'searchType', value: USERS_SEARCH_TYPES[0].value }],
		active: [
			{ value: '0', label: 'Disabled', isChecked: false },
			{ value: '1', label: 'Enabled', isChecked: false },
		],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
